import React, { useEffect, useState } from 'react';

/**
 * Componente que detecta si el visitante es un bot de búsqueda
 * y aplica técnicas para mejorar el SEO para bots
 */
const BotDetector: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isBot, setIsBot] = useState(false);

  useEffect(() => {
    // Lista de user agents de bots conocidos
    const botPatterns = [
      'googlebot', 'bingbot', 'yandexbot', 'duckduckbot', 'slurp',
      'baiduspider', 'facebookexternalhit', 'twitterbot', 'rogerbot',
      'linkedinbot', 'embedly', 'quora link preview', 'showyoubot',
      'outbrain', 'pinterest', 'slackbot', 'vkShare', 'W3C_Validator',
      'whatsapp', 'adsbot', 'mediapartners', 'applebot'
    ];

    // Comprobar si el user agent coincide con algún patrón de bot
    const userAgent = typeof navigator !== 'undefined' ? navigator.userAgent.toLowerCase() : '';
    const isSearchBot = botPatterns.some(bot => userAgent.includes(bot));

    setIsBot(isSearchBot);

    if (isSearchBot && typeof document !== 'undefined') {
      console.log('Bot detectado:', userAgent);

      // Aplicar técnicas específicas para bots
      document.documentElement.classList.add('bot-view');

      // Usar una referencia segura al documento
      const safeDocument = document;

      // Asegurar que todos los elementos estén completamente renderizados
      const timeoutId = setTimeout(() => {
        try {
          // Verificar que el documento sigue existiendo
          if (!safeDocument || !safeDocument.querySelectorAll) return;

          // Modificar enlaces externos para SEO
          const links = safeDocument.querySelectorAll('a');
          links.forEach(link => {
            // Enlaces externos deben tener rel="noopener" para seguridad
            if (link && link.hostname && window.location.hostname &&
              link.hostname !== window.location.hostname) {
              const rel = link.getAttribute('rel') || '';
              if (!rel.includes('noopener')) {
                link.setAttribute('rel', `${rel} noopener`.trim());
              }
            }
          });
        } catch (error) {
          console.error('Error al procesar SEO para bots:', error);
        }
      }, 1000);

      // Limpiar el timeout al desmontar
      return () => clearTimeout(timeoutId);
    }

    return undefined;
  }, []);

  return (
    <>
      {/* Renderizar el contenido normal */}
      {children}

      {/* Si es un bot, añadir información adicional para SEO */}
      {isBot && (
        <div className="seo-bot-info" style={{ display: 'none' }}>
          <div itemScope itemType="https://schema.org/WebSite">
            <meta itemProp="url" content="https://domired.top/" />
            <meta itemProp="name" content="Domired - Red Social Dominicana" />
          </div>
        </div>
      )}
    </>
  );
};

export default BotDetector;
